var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#466dec;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1896",
    "data-name": "Group 1896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_794",
    "data-name": "Group 794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_793",
    "data-name": "Group 793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_477",
    "data-name": "Path 477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.58,76.92A3,3,0,0,1,6.3,72L38.58,34a3,3,0,0,1,4.57,0L54.55,47.4,88.15,7.88a3,3,0,0,1,4.57,3.89L56.84,54a3,3,0,0,1-4.57,0L40.87,40.57l-30,35.29A3,3,0,0,1,8.58,76.92Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_478",
    "data-name": "Path 478"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.44,36.4a3,3,0,0,1-3-3V12.82H66.86a3,3,0,0,1,0-6H90.44a3,3,0,0,1,3,3V33.4A3,3,0,0,1,90.44,36.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_479",
    "data-name": "Path 479"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.44,93H8.58a3,3,0,0,1-3-3V9.82a3,3,0,0,1,3-3H31.64a3,3,0,0,1,0,6H11.58V87H87.44V73.5a3,3,0,0,1,6,0V90A3,3,0,0,1,90.44,93Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/Progress.9bfdd22f60e6383b922c152a4526f2cc.svg";
export { ForwardRef as ReactComponent };